// extracted by mini-css-extract-plugin
module.exports = {"page-entrance":"entrance_page-entrance__2CWng","main":"entrance_main__1gPxg","logo":"entrance_logo__2gXZe"};